import { INIT_SIDEBAR, SHOW_SIDEBAR, SHOW_SIDEBAR_COLLAPSE } from './types/index';

export const showSidebar = value => async dispatch => {
  dispatch({ type: SHOW_SIDEBAR, payload: value });
};
export const showSidebarCollapse = value => async dispatch => {
  dispatch({ type: SHOW_SIDEBAR_COLLAPSE, payload: value });
};
export const initSidbar = () => async dispatch => {
  dispatch({ type: INIT_SIDEBAR });
};
